import { Navigation, Separator } from '@cannect/new-components/atoms'
import { TMenu, TMenuColumn } from './types'
import { cloneElement, Fragment } from 'react'

const renderMenuItem = (item: TMenu, currentRoute: string, withSheetClose?: boolean, isNested = false) => {
  const {
    title,
    path,
    icon: SubIcon,
    onClick,
    external,
    divider,
    iconPlacement: subIconPlacement = 'left',
    submenu
  } = item

  if (divider) {
    return <Separator className="my-2" />
  }

  return (
    <div key={path || title}>
      <Navigation.MenuLink
        className={`${isNested ? 'pl-2 !text-xs' : '!text-sm'} xl:!text-primary-700 ${submenu ? 'font-semibold' : ''} block whitespace-nowrap px-2 py-1 leading-relaxed`}
        withSheetClose={withSheetClose}
        isExternal={external}
        to={path ?? '#'}
        onClick={() => {
          onClick?.()
        }}
        active={currentRoute === path}>
        {SubIcon && subIconPlacement === 'left' && cloneElement(SubIcon)}
        {title}
        {SubIcon && subIconPlacement === 'right' && cloneElement(SubIcon)}
      </Navigation.MenuLink>
      {submenu && (
        <div className="ml-4 mt-1">
          {submenu
            .filter((subItem) => !subItem.hidden)
            .map((subItem) => (
              <Fragment key={subItem.path || subItem.title}>
                {renderMenuItem(subItem, currentRoute, withSheetClose, true)}
              </Fragment>
            ))}
        </div>
      )}
    </div>
  )
}

export const SubMenuItem = ({
  submenu,
  columns,
  currentRoute,
  withSheetClose
}: {
  submenu?: TMenu[]
  columns?: TMenuColumn[]
  currentRoute: string
  withSheetClose?: boolean
}) => {
  if (columns) {
    return (
      <Navigation.MenuContent className="ml-2 xl:ml-0 xl:min-w-[1000px]">
        <div className="grid grid-cols-1 gap-8 xl:grid-cols-4 xl:px-4">
          {columns.map((column, index) => (
            <div key={column.title || index} className="flex min-w-0 flex-col space-y-2">
              {column.title && <h3 className="mb-3 font-semibold text-primary-700 xl:text-base">{column.title}</h3>}
              <div className="flex flex-col gap-1">
                {column.items
                  .filter((item) => !item.hidden)
                  .map((item) => (
                    <Fragment key={item.path || item.title}>
                      {renderMenuItem(item, currentRoute, withSheetClose)}
                    </Fragment>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </Navigation.MenuContent>
    )
  }

  // Fallback to regular submenu layout
  if (submenu) {
    return (
      <Navigation.MenuContent className="ml-2 xl:ml-0">
        {submenu
          .filter((item) => !item.hidden)
          .map((item) => (
            <Fragment key={item.path || item.title}>{renderMenuItem(item, currentRoute, withSheetClose)}</Fragment>
          ))}
      </Navigation.MenuContent>
    )
  }

  return null
}
